/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Typo } from 'uikit/content';

import getShortDateTimeString from '../helpers/getShortDateTimeString';

import styles from '../styles/enrollmentInfoModal.module.scss';

const EnrollmentInfoModal = ({ dueOn = '', reason = '' }) => (
  <div className={styles.element}>
    <Typo variant="b02">
      <strong>{i18n.t('due-date')}</strong> {getShortDateTimeString(dueOn)}
    </Typo>
    {reason && (
      <Typo variant="b02">
        <strong>{i18n.t('reason')}</strong> {reason}
      </Typo>
    )}
  </div>
);

EnrollmentInfoModal.propTypes = {
  dueOn: PropTypes.string,
  reason: PropTypes.string,
};

export default EnrollmentInfoModal;
